import { useTranslation } from "react-i18next";
import styles from "./NotesPage.module.scss";
import { Layout, PageHeader, Icon } from "components";
import { useEffect, useState } from "react";
import Body from "./components/Body";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { getNotesData } from "service/NotesService";

const NotesPage = () => {
  const { t } = useTranslation('common')
  const [render,setRender] = useState(false)
  const [query, setQuery] = useState("");
  const [searchNotes, setSearchNotes] = useState([]);
  const [notes, setNotes] = useState([]);
  const getData = async () => {
    try {
      let response = await getNotesData(notes);
      setNotes(response.data)
   
    } catch (error) {
    }
  };
  useEffect(() => {
    getData();
    setRender(false)
   
  }, [render]);

  const notesAll = ((searchNotes && searchNotes.length > 0) ? searchNotes : notes).filter((note) => !note.archived);
  const notesArchive = ((searchNotes && searchNotes.length > 0) ? searchNotes : notes).filter((note) => note.archived);

  useEffect(() => {
    setSearchNotes(
    
      notes.filter((note) =>
        note.body.toLowerCase().includes(query.toLowerCase())
      )
    );
  }, [query, notes]);

  return (
    <Layout>
     <div className={styles["note-app"]}>
      <PageHeader
        icon={<Icon name="edit" size={28} />}
        title={t('auto.notespage.title', 'Заметки')}
        subtitle={t('auto.notespage.subtitle', 'Личные заметки и архив')}
      />
      <Header search={query} setQuery={setQuery} setNotes={setNotes} />
      <Body
        notesAll={notesAll}
        notesArchive={notesArchive}
        setNotes={setNotes}
      />
      <Footer />
    </div>
    </Layout>
  );
};

export default NotesPage;
